import { gql } from '@apollo/client';

import { AnswerFragment } from './activity-answers.graphql';

export const STUDENT_ACTIVITY_ANSWERS_SUBSCRIPTION = gql`
  subscription StudentsActivityAnswersSubscription(
    $input: StudentsActivityAnswersSubscriptionInput!
  ) {
    studentsActivityAnswersSubscription(input: $input) {
      ...AnswerFragment
    }
  }
  ${AnswerFragment}
`;
